import ApiClient from "./apiClient";


const sshService = {
  getSshKeys:(params:{page?:number, pageSize?:number, ordering?:string|null, search?:string, filtering?:string|null}) => {
    const queryParams = new URLSearchParams();
    if(params.page) queryParams.append('page', params.page.toString());
    if(params.pageSize) queryParams.append('page_size', params.pageSize.toString());
    if(params.ordering) queryParams.append('ordering', params.ordering);
    if(params.search) queryParams.append('search', params.search);
    if(params.filtering) queryParams.append('filtering', params.filtering);
    return ApiClient.get(`pkm?${queryParams.toString()}`);
  },
  generateKeyPair: () => ApiClient.get('pkm/get_generated_key_pair'),
  createSsh:(data:any) => ApiClient.post('pkm', data),
  editSsh:(data:any) => ApiClient.put(`pkm/${data.id}`, data),
  deleteSsh:(id:string) => ApiClient.delete(`pkm/${id}`),
  getSshById:(id:string) => ApiClient.get(`pkm/${id}`)
}

export default sshService
